export default __webpack_public_path__ + "c5.png";